import React, { useEffect, useState } from 'react';
import './countdown.css';
import { inject, observer } from 'mobx-react';

const ExpiringCountdownComponent = ({ targetDate, translationsStore }) => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const diff = new Date(targetDate) - now;

    if (diff <= 0) {
      return null;
    }

    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className='countdown-container'>
      <span className='hourglass' role='img' aria-label='hourglass'>
        ⏳
      </span>
      <span className='countdown-text'>
        <i>
          {!timeLeft
            ? translationsStore.translate('InsuranceBanner.countdown.expired')
            : translationsStore
                .translate('InsuranceBanner.countdown.timeLeft')
                .replace('{days}', timeLeft.days)
                .replace('{hours}', timeLeft.hours)
                .replace('{minutes}', timeLeft.minutes)
                .replace('{seconds}', timeLeft.seconds)}
        </i>
      </span>
    </div>
  );
};

export const ExpiringCountdown = inject('translationsStore')(
  observer(ExpiringCountdownComponent)
);
